import { Controller, useForm, useFormContext, useFieldArray } from "react-hook-form";
import Select from "../../../components/form-controls/Select";
import Input from "../../../components/form-controls/Input";
import { useEffect, useId, useState } from "react";
import InvalidFeedback from "../../../components/InvalidFeedback";
import Tags from "../../../components/Tags";
import { useTranslation } from 'react-i18next';
interface FieldFormProps {
    delete: () => void,
    index: number
}

function FieldForm(defaultValues: FieldFormProps) {

    const { t }= useTranslation();
    
    const id = useId();

    const { control, watch, register, setValue, formState: { errors } } = useFormContext();
    
    const type = watch(`keys.${defaultValues.index}.type`)
    
    const isLimited = watch(`keys.${defaultValues.index}.dateConfig.isLimited`)
    const min = watch(`keys.${defaultValues.index}.dateConfig.min`)
    const max = watch(`keys.${defaultValues.index}.dateConfig.max`)

    

    useEffect(() => {
        if(type !== 'date') return

        let options = [min || 0, max || 0];
        

        setValue(`keys.${defaultValues.index}.options`, options)
        
    }, [isLimited, min, max])


    return (
        <>
            <div className="mb-3">
                <div className="row text-nowrap mb-0">
                    <div className="col">
                        <div className="mb-3">
                            <Select
                                label={t("config.forms.form-modal.select-field")}
                                data={[
                                    {
                                        value: '',
                                        text: `${t("config.forms.form-modal.list.select-option")}`,
                                        disabled: true,
                                    },
                                    {
                                        value: 'text',
                                        text: `${t("config.forms.form-modal.list.list-text")}`
                                    },
                                    {
                                        value: 'dropdown',
                                        text: `${t("config.forms.form-modal.list.list-drop-down")}`
                                    },
                                    {
                                        value: 'file',
                                        text: `${t("config.forms.form-modal.list.list-file")}`
                                    },
                                    {
                                        value: 'date',
                                        text: `${t("config.forms.form-modal.list.list-date")}`
                                    },
                                ]}
                                errors={errors?.keys?.[defaultValues.index]?.type}
                                {...register(`keys.${defaultValues.index}.type`, { required: true })}
                            />
                        </div>
                    </div>
                    <div className="col">
                        <div className="mb-3 ">
                            <Input label={t("config.forms.form-modal.name-field")} errors={errors?.keys?.[defaultValues.index]?.name} {...register(`keys.${defaultValues.index}.name`, { required: true })} />
                        </div>
                    </div>
                </div>

                {
                    type === 'dropdown' && (
                        <div className="mb-3">
                            <label className="form-label" >{t("config.forms.form-modal.list-options")}</label>
                            <Controller
                                control={control}
                                name={`keys.${defaultValues.index}.options`}
                                rules={{ required: true }}
                                render={({
                                    field: { onChange, value },
                                    fieldState: { error },
                                }) => {
                                    return (
                                        <Tags
                                            isInvalid={error ? true : false}
                                            onChange={(values: any) => onChange(values)}
                                            initialValue={Array.isArray(value) ? value.map(v => ({ value: v, label: v })) : []}
                                        />
                                    )
                                }}
                            />
                            <InvalidFeedback error={errors?.keys?.[defaultValues.index]?.options} />
                        </div>
                    )
                }

                {
                    type === 'date' && (
                        <>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={`${id}-restriction`} {...register(`keys.${defaultValues.index}.dateConfig.isLimited`)} />
                                <label className="form-check-label" htmlFor={`${id}-restriction`} >Restringir intervalo de días a seleccionar</label>
                            </div>

                            {
                                isLimited && (
                                    <div className="row">
                                        <div className="col">
                                            <div className="mb-3">
                                                <Input 
                                                    label='No. de días anteriores a la fecha del cierre de ticket *' 
                                                    errors={errors?.keys?.[defaultValues.index]?.dateConfig?.min} 
                                                    {...register(`keys.${defaultValues.index}.dateConfig.min`, { required: true, pattern: { value: new RegExp(/^\d+$/), message: 'Solo se aceptan valores mayores o iguales a 0' } } )} />
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="mb-3">
                                                <Input 
                                                    label='No. de días posteriores a la fecha del cierre de ticket*' 
                                                    errors={errors?.keys?.[defaultValues.index]?.dateConfig?.max} 
                                                    {...register(`keys.${defaultValues.index}.dateConfig.max`, { required: true, pattern: { value: new RegExp(/^\d+$/), message: 'Solo se aceptan valores mayores o iguales a 0' } })} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            
                        </>
                    )
                }

                <div className="d-flex align-items-center">
                    <div className="form-check flex-grow-1">
                        <input type="checkbox" className="form-check-input" id={`${id}-mandatory`} {...register(`keys.${defaultValues.index}.mandatory`)} />
                        <label className="form-check-label" htmlFor={`${id}-mandatory`}>{t("config.forms.form-modal.required-field")}</label>
                    </div>

                    <button className="btn btn-link text-danger" type="button" onClick={defaultValues.delete}>{t("config.forms.form-modal.delete-field")}</button>
                </div>




            </div>
            <hr />
        </>
    )
}
export default FieldForm